import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { useGetPresignedUrl } from '@/file/hooks/useGetPresignedUrl'
import { ApplicationMediaFragment } from '@gql'
import { FileTextIcon } from 'lucide-react'
import React from 'react'
import { Link } from 'react-router-dom'

type ApplicationMediasPreviewProps = {
  applicationMedia: Omit<ApplicationMediaFragment, 'file' | 'type'>
  isImage?: boolean
}
export const ApplicationMediasPreview = ({
  applicationMedia: { fileId, name },
  isImage = true,
}: ApplicationMediasPreviewProps) => {
  const { url, loading } = useGetPresignedUrl({ fileId })

  if (loading) {
    return (
      <div className="tw-w-[56px] tw-h-[56px] tw-rounded-lg tw-bg-zinc-100" />
    )
  }

  return (
    <TooltipProvider>
      <Tooltip delayDuration={0}>
        <TooltipTrigger asChild>
          {isImage ? (
            <Link to={url ?? '#'} target="_blank" className="tw-cursor-pointer">
              <img
                src={url ?? ''}
                alt="document de la candidature"
                className="tw-object-cover tw-w-[56px] tw-h-[56px] tw-rounded-lg"
              />
            </Link>
          ) : (
            <Link to={url ?? '#'} target="_blank" className="tw-cursor-pointer">
              <FileTextIcon />
            </Link>
          )}
        </TooltipTrigger>
        <TooltipContent>
          <p>{name}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
